module.exports = ".success-toast {\r\n  color: green;\r\n}\r\n"